import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

const preSave = (payload) => {
  if (payload.assignee) {
    payload.assignee = { _id: payload.assignee._id };
  }
  return payload;
};

export const task = createCrudVuexModule({
  options: { localizedFields: ["name", "description", "doneReason"] },
  preSave,
  namespaced: true,
  path: "/task",

  state: {
    isForbidden: false,
    isDownloading: false,

    showTaskDetailModal: undefined,
    showTaskCreateModal: undefined,
    task: undefined,
    form: undefined,
    isEditing: undefined,
    isCreating: false,
    //
    organizationTasksPagination: undefined,
    isOrganizationTasksLoading: false,

    organizationArchivedTasksPagination: undefined,
    isOrganizationArchivedTasksTasksLoading: false,

    myActiveTasksPagination: undefined,
    isMyActiveTasksLoading: false,

    myTasksPagination: undefined,
    isMyTasksLoading: false,

    myTaskStats: undefined,
    isMyTaskStatsLoading: false,

    organizationTaskAnalytics: undefined,
    isOrganizationTaskAnalyticsLoading: false,

    analyticsTasksPagination: undefined,
    isAnalyticsTasksLoading: false,
    //
    commentPagination: undefined,
    isCommentsLoading: false,
    isCommentCreating: false,
  },
  getters: {
    isForbidden: (state) => state.isDownloading,
    isDownloading: (state) => state.isDownloading,

    showTaskDetailModal: (state) => state.showTaskDetailModal,
    showTaskCreateModal: (state) => state.showTaskCreateModal,
    task: (state) => state.task,
    isEditing: (state) => state.isEditing,
    isCreating: (state) => state.isCreating,
    form: (state) => state.form,

    linkableTasksPagination: (state) => state.linkableTasksPagination,
    isLinkableTasksLoading: (state) => state.isLinkableTasksLoading,

    organizationTasksPagination: (state) => state.organizationTasksPagination,
    isOrganizationTasksLoading: (state) => state.isOrganizationTasksLoading,

    organizationArchivedTasksPagination: (state) => state.organizationArchivedTasksPagination,
    isOrganizationArchivedTasksLoading: (state) => state.isOrganizationArchivedTasksLoading,

    myTasksPagination: (state) => state.myTasksPagination,
    isMyTasksLoading: (state) => state.isMyTasksLoading,

    myActiveTasksPagination: (state) => state.myActiveTasksPagination,
    isMyActiveTasksLoading: (state) => state.isMyActiveTasksLoading,

    myTaskStats: (state) => state.myTaskStats,
    isMyTaskStatsLoading: (state) => state.isMyTaskStatsLoading,

    organizationTaskAnalytics: (state) => state.organizationTaskAnalytics,
    isOrganizationTaskAnalyticsLoading: (state) => state.isOrganizationTaskAnalyticsLoading,

    analyticsTasksPagination: (state) => state.analyticsTasksPagination,
    isAnalyticsTasksLoading: (state) => state.isAnalyticsTasksLoading,
    //
    commentPagination: (state) => state.commentPagination,
    isCommentsLoading: (state) => state.isCommentsLoading,
    isCommentCreating: (state) => state.isCommentCreating,

    archive: (state) => state.task.archived,
  },
  mutations: {
    isForbidden: (state, value) => (state.isDownloading = value),
    isDownloading: (state, value) => (state.isDownloading = value),

    task: (state, value) => {
      state.task = value;
      if (!value) {
        state.showTaskDetailModal = false;
      }
    },
    showTaskDetailModal: (state, value) => {
      state.showTaskDetailModal = value;
      state.isEditing = false;
      state.isCreating = false;
    },
    showTaskCreateModal: (state, value) => {
      state.showTaskCreateModal = value;
      state.showTaskDetailModal = value;
      state.isCreating = true;
      state.task = undefined;
      state.form = {};
      if (value) {
        state.isCreating = true;
      }
    },

    isEditing: (state, value) => {
      state.isEditing = value;
      if (value) {
        state.isCreating = false;
      }
    },
    isCreating: (state, value) => {
      state.isCreating = value;
      if (value) {
        state.isEditing = false;
        state.task = undefined;
      }
    },
    form: (state, value) => (state.form = value),

    organizationTasksPagination: (state, value) => (state.organizationTasksPagination = value),
    isOrganizationTasksLoading: (state, value) => (state.isOrganizationTasksLoading = value),

    organizationArchivedTasksPagination: (state, value) => (state.organizationArchivedTasksPagination = value),
    isOrganizationArchivedTasksLoading: (state, value) => (state.isOrganizationArchivedTasksLoading = value),

    isMyActiveTasksLoading: (state, value) => (state.isMyActiveTasksLoading = value),
    //myActiveTasksPagination: (state, value) => (state.myActiveTasksPagination = value),
    myTasksPagination: (state, value) => (state.myTasksPagination = value),
    isMyTasksLoading: (state, value) => (state.isMyTasksLoading = value),

    linkableTasksPagination: (state, value) => (state.linkableTasksPagination = value),
    isLinkableTasksLoading: (state, value) => (state.isLinkableTasksLoading = value),

    myTaskStats: (state, value) => (state.myTaskStats = value),
    isMyTaskStatsLoading: (state, value) => (state.isMyTaskStatsLoading = value),

    organizationTaskAnalytics: (state, value) => (state.organizationTaskAnalytics = value),
    isOrganizationTaskAnalyticsLoading: (state, value) => (state.isOrganizationTaskAnalyticsLoading = value),

    analyticsTasksPagination: (state, value) => (state.analyticsTasksPagination = value),
    isAnalyticsTasksLoading: (state, value) => (state.isAnalyticsTasksLoading = value),

    commentPagination: (state, value) => (state.commentPagination = value),
    isCommentsLoading: (state, value) => (state.isCommentsLoading = value),
    isCommentCreating: (state, value) => (state.isCommentCreating = value),

    archive: (state, value) => (state.task.archived = value),
  },
  actions: {
    async attachFile({}, { fileId, taskId }) {
      try {
        await rest.post(`/task/${taskId}/attach-file`, { fileId });
      } finally {
      }
    },
    async fetchDetail({ getters, commit, dispatch }, id) {
      try {
        commit("isLoading", true);
        commit("isForbidden", false);
        const response = await rest.get(`/task/${id}`);
        commit("task", response.data);

        return response.data;
      } catch (e) {
        if (e.status == 403) {
          commit("isForbidden", true);
        } else {
          throw e;
        }
      } finally {
        commit("isLoading", false);
      }
    },

    async fetchCurrentUserAssignedTask({ commit }, pagination = {}, clearStateBeforeRest = false) {
      commit("isMyTasksLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("myTasksPagination", undefined);
        }
        const response = await rest.post(`/task/my/paginate`, { pagination });
        commit("myTasksPagination", response.data);
        return response;
      } finally {
        commit("isMyTasksLoading", false);
      }
    },

    async fetchCurrentUserAssignedArchivedTask({ commit }, pagination = {}, clearStateBeforeRest = false) {
      commit("isMyTasksLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("myTasksPagination", undefined);
        }
        const response = await rest.post(`/task/my/paginate`, { pagination, showArchivedTasks: true });
        commit("myTasksPagination", response.data);
        return response;
      } finally {
        commit("isMyTasksLoading", false);
      }
    },
    async fetchAllActiveTasksUserAssigned({ commit }, pagination = {}, clearStateBeforeRest = false) {
      commit("isMyActiveTasksLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("myActiveTasksPagination", undefined);
        }
        const response = await rest.post(`/task/my/active/paginate`, { pagination });
        commit("myActiveTasksPagination", response.data);
        return response;
      } finally {
        commit("isMyActiveTasksLoading", false);
      }
    },

    async fetchMyTaskStats({ commit }, clearStateBeforeRest = false) {
      commit("isMyTaskStatsLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("myTaskStats", undefined);
        }
        const response = await rest.get(`/task/my/stats`);
        commit("myTaskStats", response.data);
        return response;
      } finally {
        commit("isMyTaskStatsLoading", false);
      }
    },

    async fetchOrganizationTasks({ commit }, pagination = {}, clearStateBeforeRest = false) {
      commit("isOrganizationTasksLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("organizationTasksPagination", undefined);
        }
        const response = await rest.post(`/task/organization/paginate`, { pagination });
        commit("organizationTasksPagination", response.data);
        return response;
      } finally {
        commit("isOrganizationTasksLoading", false);
      }
    },

    async fetchOrganizationArchivedTasks({ commit }, pagination = {}, clearStateBeforeRest = false) {
      commit("isOrganizationTasksLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("organizationTasksPagination", undefined);
        }
        const response = await rest.post(`/task/organization/paginate`, { pagination, showArchivedTasks: true });
        commit("organizationTasksPagination", response.data);
        return response;
      } finally {
        commit("isOrganizationTasksLoading", false);
      }
    },

    async fetchLinkableTasks({ commit }, pagination = {}, clearStateBeforeRest = false) {
      commit("isLinkableTasksLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("linkableTasksPagination", undefined);
        }
        const response = await rest.post(`/task/organization/paginate`, { pagination });
        commit("linkableTasksPagination", response.data);
        return response;
      } finally {
        commit("isLinkableTasksLoading", false);
      }
    },

    async updateStatus({ commit }, task) {
      commit("isUpdating", true);
      try {
        return rest.put(`/task/status`, task);
      } finally {
        commit("isUpdating", false);
      }
    },

    async fetchOrganizationTaskAnalytics({ commit }, filters = {}) {
      commit("isOrganizationTaskAnalyticsLoading", true);
      try {
        const response = await rest.post(`/task/organization/analytics`, { filters });
        commit("organizationTaskAnalytics", response.data);
        return response;
      } finally {
        commit("isOrganizationTaskAnalyticsLoading", false);
      }
    },

    async fetchAnalyticsTasks({ commit }, pagination = {}) {
      commit("isAnalyticsTasksLoading", true);
      try {
        const response = await rest.post(`/task/organization/paginate`, { pagination });
        commit("analyticsTasksPagination", response.data);
        return response;
      } finally {
        commit("isAnalyticsTasksLoading", false);
      }
    },

    async download({ commit }, payload) {
      commit("isDownloading", true);
      try {
        const response = await rest.post("/task/download", payload);
        return response;
      } finally {
        commit("isDownloading", false);
      }
    },

    //relations
    async removeTaskPolicyRelation({ commit }, payload) {
      return rest.post(`/task-relation/policy`, payload);
    },

    async removeTaskRiskRelation({ commit }, payload) {
      return rest.post(`/task-relation/risk`, payload);
    },
    async addTaskPolicyRelation({ commit }, payload) {
      try {
        return rest.post(`/task-relation/policy/add`, payload);
      } finally {
      }
    },

    async addTaskRiskRelation({ commit }, payload) {
      try {
        return rest.post(`/task-relation/risk/add`, payload);
      } finally {
      }
    },

    //comments

    async paginateComments({ commit }, { pagination, taskId }) {
      commit("isCommentsLoading", true);
      try {
        const response = await rest.post(`/task-comment/${taskId}/paginate`, { pagination });
        commit("commentPagination", response.data);
        return response;
      } finally {
        commit("isCommentsLoading", false);
      }
    },

    async createComment({ commit }, item) {
      commit("isCommentCreating", true);
      try {
        return await rest.post(`/task-comment`, { item });
      } finally {
        commit("isCommentCreating", false);
      }
    },

    async deleteComment({ commit }, commentId) {
      await rest.delete(`/task-comment/${commentId}`);
    },

    //
  },
});
